import React from 'react';
import AddVendorRepsContainer from '../../../Containers/UserContainer/AddVendorReps';

const AddVendorRepsScreen = () => {
  return <AddVendorRepsContainer />;
};

export default AddVendorRepsScreen;
